import { createContext } from 'react';
export const RoutePrefixContext = createContext("");
